import React,{useState,useEffect, useRef} from 'react'

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Print } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useAppData } from '../../../../../../context/AppDataContext';
import moment from 'moment';



const CellActions = (props) =>{
    return(
        <>
            {(props.data.voucherType === "Sale" || props.data.voucherType === "Purchase") &&
                <Link to={`/voucher/sale-purchase/details/${props.data.id}`}>{props.data.voucherNo}</Link>
            }
            {(props.data.voucherType === "Payment" || props.data.voucherType === "Receipt") &&
                <Link to={`/voucher/payment-receipt/details/${props.data.id}`}>{props.data.voucherNo}</Link>
            }
            {(props.data.voucherType === "Contra" || props.data.voucherType === "Journal") &&
                <Link to={`/voucher/contra-journal/details/${props.data.id}`}>{props.data.voucherNo}</Link>
            }
            {(props.data.voucherType === "CreditNote" || props.data.voucherType === "DebitNote") &&
                <Link to={`/voucher/contra-journal/details/${props.data.id}`}>{props.data.voucherNo}</Link>
            }
            {(props.data.voucherType === "Expense" ) &&
                <Link to={`/voucher/expense/details/${props.data.id}`}>{props.data.voucherNo}</Link>
            }
            {(props.data.voucherType === "ChallanIn" || props.data.voucherType === "ChallanOut") &&
                <Link to={`/voucher/challan/details/${props.data.id}`}>{props.data.voucherNo}</Link>
            }
        </>
    )
}

function DaybookDataGrid({voucherList,getVoucherList}) {
    const gridRef = useRef();
    const {userDD,ledgerDD,getDDDataById} = useAppData();

    const [defaultColDef] = useState({
        floatingFilter: true,
        filterParams: {
          buttons: ['apply'],
        },
        resizable: true,
        width:120,
        filter:true,
        sortable: true,
        cellStyle: { 'textTransform': 'uppercase' },
    });


    const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
        let _columnDefs = [
            {headerName: "Date", width:150,
              valueGetter:params=>{
                return moment(params.data.updated_at).format("LL")
              }
            },
            {field:"ledgerId",headerName: "Particulars", width:300,
              valueGetter:params=>{
                return getDDDataById(ledgerDD,params.data.ledgerId).label;
              }
            },
            {headerName:"Voucher#", width:"150", valueGetter: params => params.data.title,
                cellRenderer: CellActions,
                cellRendererParams: {
                    callBack:getVoucherList,
                    //remove:remove
                },
            },   
            {field:"voucherType",headerName: "V.Type"},
            {field:"grandTotal",headerName: "Amount",width:200},
        ];
        setColumnDef(_columnDefs);
    }
    
    const onBtnExport = () => {
        gridRef.current.api.exportDataAsCsv("data.csv");
    };
    
    useEffect(()=>{    
        prepairColumnDef();
    },[]);

    return (
        <div className='row'>
              <div className='col-md-12'>
                <div className="ag-theme-alpine" style={{height: 600}}>
                <AgGridReact
                    ref={gridRef}
                    rowData={voucherList}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    animateRows={true}
                    //onGridReady={getVoucherList}
                />
                </div>
            </div>
        </div>
    )
}

export default DaybookDataGrid